export const NonEmptyMessage = 'Este campo deve ser preenchido!';